/* =============================================================================
   Lucid Light — collection page: the "in stock now, either size" filter.

   A separate module from lucid.js on purpose. That file is 111KB and several
   agents edit it at once; this is ~90 lines that only ever run on a collection
   page, and the section only emits the <script> tag when it actually renders
   the bar.

   THE ONE RULE THIS FILE MUST NOT BREAK: it does not know what a size is.
   Every card carries data-sizes — three characters, a/o/n, one per slot, in
   slot order — produced by snippets/lucid-size-slots.liquid, which is the only
   place in the theme allowed to decide that "7.5oz" and "7.5 oz" are the same
   thing. This module compares characters at an index and nothing else. If you
   ever find yourself writing a string like "17" in here, the fix belongs in
   that snippet instead.

   Semantics, from the operator (2026-08-23): "in stock now, either size".
     - 'a' matches. 'o' (sold out) and 'n' (not offered) do not. A badge means
       BUYABLE right now, not "we make it".
     - Two badges is OR. `.some()`, never `.every()` — "either size" is a
       request to widen.
     - Nothing pressed is not a filter; every card shows.
   ========================================================================== */
(function () {
  "use strict";

  var bar = document.querySelector("[data-size-filter]");
  if (!bar) return;

  var grid = document.querySelector("[data-size-filter-grid]");
  if (!grid) return;

  var badges = Array.prototype.slice.call(bar.querySelectorAll("[data-size-slot]"));
  var status = bar.querySelector("[data-size-filter-status]");
  var empty = bar.querySelector("[data-size-filter-empty]");
  var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-sizes]"));
  if (!badges.length || !cards.length) return;

  /* The noun comes down as data, not as something to parse back out of the
     rendered count. Deriving it from "10 scents" works right up until the
     collection holds one product and the server has already written the
     singular -- then stripping a trailing "s" yields "scen". The section owns
     the word; this only reads it. */
  var NOUN_ONE = (status && status.getAttribute("data-noun")) || "scent";
  var NOUN_MANY = (status && status.getAttribute("data-noun-plural")) || "scents";

  function noun(n) { return n === 1 ? NOUN_ONE : NOUN_MANY; }

  /* The `hidden` attribute is the no-JS guarantee: the server never renders
     controls that only JS can operate. Removing it here is the first thing
     that happens, and it happens before any listener is attached so a visitor
     cannot click a badge that is not wired yet. */
  bar.hidden = false;

  function selected() {
    return badges
      .filter(function (b) { return b.getAttribute("aria-pressed") === "true"; })
      .map(function (b) { return parseInt(b.getAttribute("data-size-slot"), 10); });
  }

  function apply() {
    var want = selected();
    var shown = 0;

    cards.forEach(function (card) {
      var states = card.getAttribute("data-sizes") || "";
      /* OR, deliberately: `some`. See the header. */
      var match = want.length === 0 || want.some(function (i) {
        return states.charAt(i) === "a";
      });
      card.hidden = !match;
      if (match) shown++;
    });

    if (status) {
      status.textContent = want.length === 0
        ? shown + " " + noun(shown)
        : shown + " of " + cards.length + " " + noun(cards.length);
    }
    if (empty) empty.hidden = shown !== 0;
  }

  badges.forEach(function (b) {
    b.addEventListener("click", function () {
      b.setAttribute("aria-pressed",
        b.getAttribute("aria-pressed") === "true" ? "false" : "true");
      apply();
    });
  });

  apply();
})();
